module.exports = __webpack_public_path__ + "media/images/invites-792b32928b4ec1080acdf0cc12c42274.png";